/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cli_3_DescInputs */

const en_mk_cli_3_desc = /** @type {(inputs: Mk_Cli_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Existing plan and task tools remain available. Six workflow controls add listing, details, start, stop, resume, and messages for your agent team.`)
};

const id_mk_cli_3_desc = /** @type {(inputs: Mk_Cli_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alat rencana dan tugas tetap tersedia. Enam kontrol workflow menambahkan daftar, detail, mulai, berhenti, lanjutkan, dan pesan untuk tim agent.`)
};

/**
* | output |
* | --- |
* | "Existing plan and task tools remain available. Six workflow controls add listing, details, start, stop, resume, and messages for your agent team." |
*
* @param {Mk_Cli_3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cli_3_desc = /** @type {((inputs?: Mk_Cli_3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cli_3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cli_3_desc(inputs)
	return en_mk_cli_3_desc(inputs)
});